import {connect} from 'react-redux';
import {
  clearMessageData,
  getNotificationMessagePage,
  markAsDeleted,
  resetLoadMoreNotificationMessages,
} from 'shared/notification-center/actions/notification-messages';
import {getFollowedCollegeIds} from 'shared/notification-center/actions/colleges';
import {getUserId} from 'shared/notification-center/actions/user';
import {clearColleges} from 'shared/actions/college';
import {bindActionCreators} from 'redux';
import NotificationCenterBody from '..';

const mapStateToProps = ({
  microscholarshipsLoading,
  student,
  notificationMessageIndexes,
  loadMoreNotificationMessages,
}) => ({
  microscholarshipsLoading,
  student,
  loadMoreNotificationMessages,
  notificationMessageIndexes: Array.from(notificationMessageIndexes),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getNotificationMessagePage,
      getStudentId: getUserId,
      markAsDeleted,
      getFollowedCollegeIds,
      clearColleges,
      clearMessageData,
      resetLoadMoreNotificationMessages,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(NotificationCenterBody);
